import { gql } from "@apollo/client"

export const GET_COMPANIES_IN_REGION = gql`
  query GetCompaniesInRegion($country: String, $city: String, $serviceId: ID) {
    getCompaniesInRegion(country: $country, city: $city, service_id: $serviceId) {
      id
      title
      email
      user_name
      name
      operator_licence_number
      country_code
      phone_number
      currency
      eye_balance
      vat
      mobile_verified
      email_verified
      created_at
      vat_id
      company_city
      company_address
      company_country
      company_county
      company_postalcode
      tax_id
      app_name
      admin {
        first_name
        last_name
        date_of_birth
        city
        address
        postal_code
      }
      company_operation_city
    }
  }
`